




























import { defineComponent } from "@nuxtjs/composition-api";
import { PropType } from "vue";

export default defineComponent({
  props: {
    productGallery: {
      type: Array as PropType<{
          desktop ?: {url: string},
          mobile ?: {url: string},
          tablet ?: {url: string},
          alt: string
        }[]>,
      required: true,
    },
  },
});
